export default __webpack_public_path__ + "static/media/gettingStartedReact.98189561.md";